import React from 'react';

/** How many finished quests the ribbon names before it folds the rest into "+N". */
export const COMPLETED_RIBBON_LIMIT = 3;

/**
 * "Completed: First Hunt" (plan 23 row 44): the quests this NPC gave or
 * receives that the reader has finished, most recent first.
 */
export const NpcCompletedRibbon: React.FC<{ quests?: ReadonlyArray<{ id: string; title: string }> }> = ({ quests }) => {
  if (!quests?.length) return null;
  const shown = quests.slice(0, COMPLETED_RIBBON_LIMIT);
  const more = quests.length - shown.length;
  return <p className="npc-completed-ribbon" data-testid="npc-completed-ribbon"
    aria-label={`Completed: ${quests.map(q => q.title).join(', ')}`}>
    <span className="npc-completed-ribbon-mark" aria-hidden="true">✓</span>
    <span className="npc-completed-ribbon-label">Completed</span>
    {shown.map(q => <span key={q.id} className="npc-completed-ribbon-quest" data-quest-id={q.id}>{q.title}</span>)}
    {more > 0 && <span className="npc-completed-ribbon-more">+{more} more</span>}
  </p>;
};
